import React, { Fragment, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import Button from "@material-ui/core/Button";
import { logOut } from "./authActions";
import { notBlank } from "../util/ext";
import Grid from "@material-ui/core/Grid";
import UserProfileSwitchOrgsMenu from "../components/UserProfileSwitchOrgsMenu";
import { useHistory } from "react-router-dom";
import { useIsIapReviewer } from "./authUtils";
import { Link } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  container: {
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "white",
  },

  header: {
    fontSize: "3rem",
    color: theme.palette.error.main,
  },

  message: {
    fontSize: "1.6rem",
    color: theme.palette.error.main,
  },
}));

const Unauthorized = props => {
  const { message } = props;
  const classes = useStyles();
  const reduxDispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const isIapReviewer = useIsIapReviewer();
  const history = useHistory();
  const goBack = () => history.goBack();

  const [openMenu, setOpenMenu] = useState(false);
  const handleToggleMenu = () => setOpenMenu(!openMenu);

  useEffect(() => {
    if (isIapReviewer) {
      history.replace("/creator/organize?view=review,pending");
    }
  }, [isIapReviewer, history]);

  return (
    <div className={classes.container}>
      <h1 className={classes.header}>Unauthorized!</h1>
      <h4 className={classes.message}>{message}</h4>
      {isIapReviewer && (
        <Button
          variant="text"
          color="primary"
          component={Link}
          to="/creator/organize?view=review,pending"
        >
          Go to Review
        </Button>
      )}
      <Grid container justify="center">
        <Button variant="text" color="primary" onClick={goBack}>
          Go Back
        </Button>
        {notBlank(auth) && (
          <Fragment>
            <Button
              variant="text"
              color="primary"
              onClick={() => reduxDispatch(logOut())}
            >
              Log Out
            </Button>

            {auth?.user?.organizations?.length > 1 && (
              <UserProfileSwitchOrgsMenu
                onClose={handleToggleMenu}
                closeDropDown={() => setOpenMenu(false)}
              />
            )}
          </Fragment>
        )}{" "}
      </Grid>
    </div>
  );
};

export default Unauthorized;
